import { Injectable, inject } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

type LogMessage = string | object | (() => string | object);
type LogAdditional = unknown[];

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private readonly logger = inject(NGXLogger);

  public trace(message?: LogMessage, ...additional: LogAdditional): void {
    this.logger.trace(message, ...additional);
  }
  public debug(message?: LogMessage, ...additional: LogAdditional): void {
    this.logger.debug(message, ...additional);
  }
  public info(message?: LogMessage, ...additional: LogAdditional): void {
    this.logger.info(message, ...additional);
  }
  public log(message?: LogMessage, ...additional: LogAdditional): void {
    this.logger.log(message, ...additional);
  }
  public warn(message?: LogMessage, ...additional: LogAdditional): void {
    this.logger.warn(message, ...additional);
  }
  public error(message?: LogMessage, ...additional: LogAdditional): void {
    this.logger.error(message, ...additional);
  }
  public fatal(message?: LogMessage, ...additional: LogAdditional): void {
    this.logger.fatal(message, ...additional);
  }
}
